import type { UseCase } from '@/core/shared'
import type { AccessConfigRepository } from '../domain'

export const editAccessConfig: UseCase<AccessConfigRepository, 'editAccessConfig'> = (repository) => {
  return async (accessConfigEdit) => {
    await repository.editAccessConfig(accessConfigEdit)
  }
}
